/**
 * Post filter bar (blog/category archives and [post_filters]): category select + search, as normal page loads.
 * The select's option values are category URLs; the search is sent as ?search=.
 */
function setupPostFilters(form) {
  const select = form.querySelector('.dmn-post-filters__category');
  const search = form.querySelector('.dmn-post-filters__input');

  // Build the URL ourselves so an empty search doesn't leave "?search=" behind.
  const submit = () => {
    const url = new URL(form.action, window.location.href);
    const term = search.value.trim();

    if (term) {
      url.searchParams.set('search', term);
    } else {
      url.searchParams.delete('search');
    }

    window.location.assign(url.toString());
  };

  select?.addEventListener('change', () => {
    form.action = select.value;
    // On archives a category choice navigates straight away; the shortcode waits for the search to be submitted.
    if (form.dataset.mode === 'navigate') submit();
  });

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    submit();
  });
}

export function initPostFilters(root = document) {
  root.querySelectorAll('.dmn-post-filters').forEach((form) => {
    if (form.dataset.ready) return;
    form.dataset.ready = '1';
    setupPostFilters(form);
  });
}
